module.exports = `
  type Token {
    token_validate: Boolean!
  }
`;
